import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { FontSizeDecoration, NodeViewDecorator } from './../../ricos-types/index.js';

import type { FontSizeCommonConfig } from './types.js';

const decorator = (
  element: JSX.Element,
  fontSizeDecoration: FontSizeDecoration,
  config?: FontSizeCommonConfig
) => {
  const { unit, value } = fontSizeDecoration.fontSizeData || {};
  const fontSize =
    config?.overrideInlineFontSize && value
      ? config.overrideInlineFontSize(value?.toString() ?? '', unit)
      : `${value}${unit ? unit.toLowerCase() : 'px'}`;

  return (
    <span
      key={`fontsize-${element.key}`}
      style={{
        fontSize,
      }}
    >
      {element}
    </span>
  );
};

const createFontSizeDecorator = (
  config?: FontSizeCommonConfig
): NodeViewDecorator<JSX.Element> => ({
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.FONT_SIZE),
  decorate: ({ element, node }) => {
    const fontSizeDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.FONT_SIZE
    ) as FontSizeDecoration;
    return decorator(element as JSX.Element, fontSizeDecoration, config);
  },
});

export { createFontSizeDecorator };
